import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ICanvasTestViewStrings extends LocalizedStringsMethods {
    lsStimulusTxt: string;
    lsBaselinext: string;
    lsCurrentTestxt: string;
    lsBaselineScore: string;
    lsTestScore: string;
}

let strings: ICanvasTestViewStrings;
export default strings = new LocalizedStrings({
    en: {
        lsStimulusTxt: 'STIMULUS',
        lsBaselinext: 'BASELINE',
        lsCurrentTestxt: 'CURRENT TEST',
        lsBaselineScore: 'Focus Baseline Score',
        lsTestScore: 'Focus Test Score',
    },
    es: {
        lsStimulusTxt: 'ESTÍMULO',
        lsBaselinext: 'BASE',
        lsCurrentTestxt: 'PRUEBA ACTUAL',
        lsBaselineScore: 'Enfoque Puntaje de referencia',
        lsTestScore: 'Puntuación de prueba de enfoque',
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.canvastestview.tsx